import { render, staticRenderFns } from "./pageFooter.vue?vue&type=template&id=6e1190a4&scoped=true&"
import script from "./pageFooter.vue?vue&type=script&lang=js&"
export * from "./pageFooter.vue?vue&type=script&lang=js&"
import style0 from "./pageFooter.vue?vue&type=style&index=0&id=6e1190a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1190a4",
  null
  
)

export default component.exports